

import React from 'react';
import { connect } from 'react-redux';
import Network from '../../Utils/network.js';
import { setContextParameters } from '../../General/Actions.js';
import { setIsUserLoggedInTrue, setIsUserLoggedInFalse, setUserDetails, setConfigurationValues, setSiteKey } from '../../General/Actions.js';
import LoginPageRootComponent from '../LoginPage/LoginPageRoot';
import PortalPageNewComponent from '../PortalPage/PortalPageNew.js';

class SplashScreenComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {

        //Network.executeAxios("getContextParameters", "GET", {}, (getContextParametersResponse) => {
        Network.executeAxios("getAllConfigurations", "GET", {}, (getAllConfigurationsResponse) => {
            // Network.executeAxios("getRecaptchaSiteKey", "GET", {}, (siteKeyResponse) => {
                //this.props.setSiteKey("siteKey", siteKeyResponse.SITEKEY);
                //this.props.setContextParameters("contextParameters",getContextParametersResponse);
                this.props.setConfigurationValues(getAllConfigurationsResponse);
                
            //})
        })
        //})

        var isUserLoggedIn = localStorage.getItem("isUserLoggedIn");
        var userEmail = localStorage.getItem("userEmail");
        var userMsisdn = localStorage.getItem("userMsisdn");
        if (isUserLoggedIn === "true") {
            this.props.setUserDetails("email", userEmail);
            this.props.setUserDetails("msisdn", userMsisdn);
            this.props.setIsUserLoggedInTrue();
            // setTimeout(()=>{
            //     this.props.setIsUserLoggedInTrue();
            // },1000);
        } else {
            this.props.setIsUserLoggedInFalse();
        }

    }

    render() {
        if (this.props.isUserLoggedIn) {
            return (<PortalPageNewComponent />);
        } else {
            return (<LoginPageRootComponent />);
        }

    }
}


const mapStateToProps = (state, ownProperties) => {
    return {
        isUserLoggedIn: state.isUserLoggedIn,
        contextParameters: state.contextParameters,
        configurationValues: state.configurationValues
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setIsUserLoggedInTrue: function () {
            dispatch(setIsUserLoggedInTrue());
        },
        setIsUserLoggedInFalse: function () {
            dispatch(setIsUserLoggedInFalse());
        },
        setUserDetails: function (key, payload) {
            dispatch(setUserDetails(key, payload));
        },
        setContextParameters: function (key, payload) {
            dispatch(setContextParameters(key, payload));
        },
        setConfigurationValues: function (payload) {
            dispatch(setConfigurationValues(payload));
        },
        setSiteKey: function (key, payload) {
            dispatch(setSiteKey(key, payload));
        }
    }
}

const SplashScreenComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SplashScreenComponent)


export default SplashScreenComponentContainer;


